<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('/businesses/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('common_words.add_company') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameBusinessSelected"
            :visible.sync="modals.read"
            width="70%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-header custom-shadow-card-header">
                <strong
                  >{{ $t('common_words.company') }}: {{ rowData.name }}</strong
                >
              </div>
              <div class="card-body" v-if="rowData">
                <p class="card-text">
                  <strong>{{ $t('common_words.nit') }}: </strong>
                  {{ rowData.nit }} <br />
                  <strong>{{ $t('common_words.code') }}:</strong>
                  {{ rowData.code ? rowData.code : 'No asignado' }} <br />
                  <strong>{{ $t('common_words.cost_center') }}:</strong>
                  {{
                    rowData.cost_center ? rowData.cost_center : 'No asignado'
                  }}
                  <br />
                  <strong>{{ $t('common_words.sub_center') }}:</strong>
                  {{ rowData.sub_center ? rowData.sub_center : 'No asignado' }}
                  <br />
                  <strong>{{ $t('common_words.group') }}:</strong>
                  {{ rowData.group ? rowData.group : 'No asignado' }}
                  <br />
                  <strong>{{ $t('common_words.name') }}:</strong>
                  {{ rowData.name }}
                  <br />
                  <strong>{{ $t('common_words.comercial_name') }}:</strong>
                  {{ rowData.tradename }} <br /><strong
                    >{{ $t('common_words.comercial_activity') }}:
                  </strong>
                  {{ rowData.comercial_activity }} <br /><strong
                    >{{ $t('common_words.guild') }}:</strong
                  >
                  {{
                    rowData.comercial_activity
                      ? rowData.comercial_activity
                      : 'No asignado'
                  }}
                  {{ rowData.about_you }}
                  <br />
                  <strong>{{ $t('common_words.address') }}: </strong>
                  {{ rowData.city }}, {{ rowData.state }} -
                  {{ rowData.country }};
                  {{ rowData.address }}

                  <br /><strong>{{ $t('common_words.email') }}: </strong>
                  {{ rowData.email }} <br /><strong
                    >{{ $t('common_words.phone') }}:
                  </strong>
                  {{ rowData.phone }} <br /><strong
                    >{{ $t('common_words.website') }}:
                  </strong>
                  {{ rowData.web_site }}
                </p>
                <table class="table">
                  <tbody>
                    <tr>
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.types_of_companies')
                            }}:</strong
                          >
                        </h6>
                        <br />
                        <span v-if="rowData.types.length > 0">
                          <span
                            v-for="(type, index) in rowData.types"
                            :key="index"
                          >
                            <el-tag type="info">{{ type.type }}</el-tag>
                          </span>
                        </span>
                        <el-tag v-else type="info">{{
                          $t('common_words.no_assignment')
                        }}</el-tag>
                      </td>
                    </tr>
                    <tr v-if="rowData.business_groupings.length > 0">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.group_companies') }}:</strong
                          >
                        </h6>
                        <br />
                        <span
                          v-for="(name, index) in rowData.business_groupings"
                          :key="index"
                        >
                          <el-tag type="info">{{ name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.contact') }}:</strong>
                        </h6>
                        <br />
                        <span
                          v-for="contact in rowData.business_contacts"
                          :key="contact.name"
                        >
                          <el-tag type="info"
                            >{{ $t('common_words.name') }}: {{ contact.name }},
                            {{ $t('common_words.position') }}:
                            {{ contact.position }},
                            {{ $t('common_words.phone_shortversion') }}:
                            {{ contact.phone }}</el-tag
                          >
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.area') }}:</strong>
                        </h6>
                        <br />
                        <span v-for="area in rowData.areas" :key="area.name">
                          <el-tag type="info">{{ area.name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.assigned_farms') }}:</strong
                          >
                        </h6>
                        <br />
                        <span
                          v-for="farm in getDataUniqueObject(
                            rowData.id,
                            rowData.farms
                          )"
                          :key="farm.name"
                        >
                          <el-tag type="info">{{ farm.name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.associated_modules')
                            }}:</strong
                          >
                        </h6>
                        <br />
                        <span
                          v-for="mod in getDataUniqueObject(
                            rowData.id,
                            rowData.modules
                          )"
                          :key="mod.name"
                        >
                          <el-tag type="info">{{ mod.name }}</el-tag>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.associated_clime_api')
                            }}:</strong
                          >
                        </h6>
                        <br />
                        <template
                          v-if="rowData.business_weather_apis.length > 0"
                        >
                          <span
                            v-for="(
                              stations, index
                            ) in rowData.business_weather_apis"
                            :key="`${stations.station_mark}-${index}`"
                          >
                            <el-tag type="info">
                              {{ stations.station_mark }}
                            </el-tag>
                          </span>
                        </template>
                        <el-tag v-else type="secondary"
                          >{{ $t('common_words.no_associated_record') }}
                        </el-tag>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              :data="queriedData"
              style="width: 100%"
              :border="true"
            >
              <el-table-column
                type="index"
                width="65"
                :align="'center'"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                v-if="isShow() || isUpdate() || isDelete()"
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="getTextTooltipDelete(props.row)"
                      :class="`btn-${
                        props.row.deleted_at ? `info` : `danger`
                      } btn-simple btn-link custom-margin-actions`"
                      @click="
                        props.row.deleted_at
                          ? handleActivate(props.$index, props.row)
                          : handleDelete(props.$index, props.row)
                      "
                    >
                      <em
                        :class="`fa ${
                          props.row.deleted_at ? `fa-check-circle` : `fa-times`
                        } custom-size-fa-actions`"
                      ></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { objectsUnique } from 'src/util/Util';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './businessTable';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,

    nameBusinessSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },

  data() {
    return {
      businessForm: {
        name: null,
      },
      businessFormEdit: {
        name: null,
      },
      Table: {},
      Search: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        delete: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    getDataUniqueObject(businessId, object, key = 'name') {
      if (businessId === 1) {
        return [{ id: 1, name: i18n.t('common_words.all_associated_records') }];
      }
      const uniques = objectsUnique(object, key);
      return uniques.length === 0
        ? [{ id: 1, name: i18n.t('common_words.all_associated_records') }]
        : uniques;
    },

    getTextTooltipDelete(row) {
      if (row.deleted_at) return i18n.t('common_words.activate');
      else return i18n.t('common_words.deactivate');
    },

    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(_, row) {
      this.rowData = row;
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      row.url_path_form = '/businesses/edit';
      this.businessForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.businessForm));
      this.$router.push({
        path: 'businesses/edit',
      });
    },

    handleDelete(_, row) {
      this.businessForm = row;
      SweetAlert.delete(
        i18n.t('common_words.the_company') + ' ' + this.businessForm.name
      ).then((result) => {
        if (result.value) this.deleteBusiness();
      });
    },

    handleActivate(_, row) {
      this.businessForm = row;
      SweetAlert.confirm(
        i18n.t('common_words.activate') +
          ' ' +
          i18n.t('common_words.the_company') +
          ' ' +
          this.businessForm.name,
        i18n.t('show_notification.business.activate_company_confirm')
      ).then((result) => {
        if (result.value) this.activateBusiness();
      });
    },

    deleteBusiness() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.businessForm.route = 'businesses';
        Axios.destroyMaster(this.businessForm)
          .then((response) =>
            this.modifyTable(1, this.businessForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    activateBusiness() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.businessForm.route = 'businesses/activate';
        Axios.updateMaster(this.businessForm)
          .then((response) =>
            this.modifyTable(1, this.businessForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      this.PDF({
        route: 'businesses/pdf',
        name_file: 'empresas.pdf',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      this.Excel({
        route: 'businesses/excel',
        name_file: 'empresas.xlsx',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table, Search } = configTable();
      this.Table = Table;
      this.Search = Search;
      this.tableColumns = Table.tableColumns;
      this.pagination = Table.pagination;
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('businesses')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('businesses');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('businesses');
  },
};
</script>
<style></style>
